export default {"src":"/_next/static/media/easier-3.55167fe7.svg","height":52,"width":42,"blurWidth":0,"blurHeight":0};